import React from 'react';
import Scrollbars from 'react-custom-scrollbars';

import OrderRealizationsAdjustedItem from '../order-realizations-adjusted-item/order-realizations-adjusted-item';
import { OrderRealizationsAdjustedItemProps } from '../types';

import './order-realizations-adjusted-list.scss';

interface OrderRealizationsListProps {
  data: OrderRealizationsAdjustedItemProps[];
}

const OrderRealizationsAdjustedList: React.FC<OrderRealizationsListProps> = ({
  data,
}) => (
  <Scrollbars autoHide>
    <ul className="realization-adjust__list">
      {data.map((item, index) => (
        <li key={`${item.title}-${index}`} className="realization-adjust__item">
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <OrderRealizationsAdjustedItem {...item} />
        </li>
      ))}
    </ul>
  </Scrollbars>
);

export default OrderRealizationsAdjustedList;
